import { render, staticRenderFns } from "./ShoppingCartResume.vue?vue&type=template&id=7358de9c&"
import script from "./ShoppingCartResume.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartResume.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartResume.vue?vue&type=style&index=0&id=7358de9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports